import { toValue, type MaybeRefOrGetter } from '@vueuse/core';
import { useGiftBasic } from './useGiftBasic';
import { useGiftConsolidated } from './useGiftConsolidated';
import { GIFT_CARD_TYPE as GCT } from '../constants/giftcard';

export const useGift = (giftCardType: MaybeRefOrGetter<GCT> = GCT.BASIC) =>
  toValue(giftCardType) === GCT.CONSOLIDATED_MASTER ? useGiftConsolidated() : useGiftBasic();
